import { Button, TableCell } from "@mui/material";
import React, { useState } from "react";
import ViewServiceModal from "./view-service-modal";

const DataTableColumn = ({ row, column, value }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);

  // Function to safely render the value
  const renderValue = (value) => {
    if (typeof value === "string" || typeof value === "number") {
      return value;
    } else if (typeof value === "object" && value !== null) {
      // Handle objects by converting them to a string
      return JSON.stringify(value);
    } else {
      // Fallback for other cases
      return "N/A";
    }
  };

  return (
    <TableCell
      key={column.id}
      style={{
        border: "1px solid #00000080",
      }}
    >
      {column.id === "action" ? (
        <>
          <Button onClick={handleOpen}>View</Button>
          <ViewServiceModal open={open} setOpen={setOpen} data={{ ...row }} />
        </>
      ) : (
        renderValue(value)
      )}
    </TableCell>
  );
};

export default DataTableColumn;
